import PropTypes from 'prop-types';
import React from 'react';
import {connect} from 'react-redux';
import moment from 'moment';

import cdn from 'app/helpers/cdn';
import Ps from 'app/helpers/publish-statuses';
import AuthSlx from 'app/selectors/auth';
import Link from 'app/components/common/link';
import PrintBtn from 'app/components/common/print-btn';
import paths from 'app/paths';
import history from 'app/history';
import RteViewer from 'app/components/common/rich-text/viewer';
import helpers from 'app/helpers/grant-system';
import Bar from 'app/components/publish-status/bar';

class GrantProgramProfile extends React.PureComponent {

  constructor(props) {
    super(props);

    this.state = {};

    this.onClickApply = this.onClickApply.bind(this);
  }

  get isUpcoming() {
    return helpers.isUpcoming(this.props.program);
  }
  get isEnded() {
    return helpers.isEnded(this.props.program);
  }
  get isActive() {
    const {program} = this.props;
    if (program?.publishStatus !== Ps.ACTIVE) return false;
    return helpers.isWithinActiveRange(this.props.program);
  }

  get statusMsg() {
    const {program} = this.props;
    const formatDate = (dateStr) => moment(dateStr).format('MMMM D, YYYY');
    if (this.isUpcoming) {
      return `Open for applications starting on ${formatDate(program.openDateStr)}.`;
    }
    if (this.isEnded) {
      return `No longer accepting applications.`;
    }
    if (program.closeDateStr) {
      return `Applications must be submitted by ${formatDate(program.closeDateStr)}.`;
    }
    return null;
  }

  get btnDisabled() {
    if (!this.isActive) return true;
    return false;
  }

  onClickApply() {
    const {editMode, program} = this.props;
    if (editMode) return;
    const applyPath = paths.grantProgramApply(program.id);
    history.push(applyPath);
  }

  renderCta() {
    const {existingAppIds, program} = this.props;
    if (existingAppIds?.length) {
      const hasMulti = existingAppIds.length > 1;
      const path = hasMulti ? paths.grantApps() : paths.grantApp(existingAppIds[0]);
      const newPath = paths.grantProgramApply(program.id);
      return (<>
        <Link href={path} className="btn large blue" style={{margin: '48px auto 0', display: 'block', width: 280}}>Resume Application</Link>
        <div className="_ta-center _mt-12">
          <Link href={newPath} className="blue-pink-hover">Apply Again</Link>
        </div>
      </>);
    }

    return <button onClick={this.onClickApply} disabled={this.btnDisabled} className="btn large blue" style={{margin: '48px auto 0', display: 'block', width: 240}}>Apply Now</button>;
  }

  render() {
    const {program, editMode} = this.props;
    const showIndexLink = !!program.company?.grantsPublicProgramsPageEnabled;

    return (<>
      <Bar entityType="GrantProgram" subtype="landingPage" entity={program} company={program.company} editMode={editMode} disablePublish />
      <div className="widther">
        <div className="box bform" style={{margin: '48px auto', width: 800}}>
          {!!(program.imgPath || editMode) && (
            <div className="" style={{backgroundColor: '#EEE', height: 300}}>
              {!!program.imgPath && (
                <img src={cdn.imgUrl(program.imgPath)} alt={program.title} style={{display: 'block', objectFit: 'cover', width: '100%', height: '100%'}} />
              )}
            </div>
          )}
          <div style={{padding: 96}}>
            <h1 className="bform-h1" style={{marginBottom: 24}}>{program.title}</h1>
            <RteViewer md={program.landingText || ''} fontSize="large" />
            {this.renderCta()}
            {!!this.statusMsg && (
              <p style={{textAlign: 'center', color: '#999', fontSize: 13}}>{this.statusMsg}</p>
            )}
          </div>
        </div>
        <div className="_flex _align-center _justify-center _gap-24 _pb-48">
          <PrintBtn href={paths.grantProgramPrint(program.id)} label="Print application form" />
          {showIndexLink && <Link href={paths.grantPrograms(program.company.slug)} className="blue-pink-hover">View more programs</Link>}
        </div>
      </div>
    </>);
  }

}

GrantProgramProfile.propTypes = {
  editMode: PropTypes.bool,
  program: PropTypes.object.isRequired,
  existingAppIds: PropTypes.arrayOf(PropTypes.string),
};

GrantProgramProfile.defaultProps = {
  editMode: false,
  existingAppIds: null,
};

const stateToProps = (state) => ({
  currentUser: AuthSlx. currentUser(state),
});

const dispatchToProps = (dispatch) => ({});

export default connect(stateToProps, dispatchToProps)(GrantProgramProfile);
